// Logotipo de PALABRIKS en SVG (estilo "Nocturno Neón" del juego). Se inyecta INLINE en el hub
// para que use la tipografía Space Grotesk de la página. Sustituye al antiguo `logo-tight.webp`
// (que se conserva en src/assets/ por si hay que recuperarlo).
// La clase `hub-logo-img` mantiene el mismo dimensionado/posición que ya estaba afinado.
export const LOGO_SVG = `
<svg class="hub-logo-img" viewBox="0 0 660 510" role="img" aria-label="PALABRIKS" draggable="false" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="pk-hero" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#2a3556"/><stop offset="1" stop-color="#111a31"/>
    </linearGradient>
    <linearGradient id="pk-under" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0" stop-color="#eef2fb"/><stop offset="0.24" stop-color="#a3e15c"/>
      <stop offset="0.46" stop-color="#f2c14e"/><stop offset="0.68" stop-color="#ef7a4e"/>
      <stop offset="0.86" stop-color="#a479e6"/><stop offset="1" stop-color="#5fe0d0"/>
    </linearGradient>
    <filter id="pk-glow" x="-45%" y="-45%" width="190%" height="190%">
      <feGaussianBlur stdDeviation="7" result="b"/>
      <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
    </filter>
  </defs>

  <!-- Emblema: pila de fichas neón -->
  <g transform="rotate(-13 245 182)">
    <rect x="163" y="100" width="165" height="165" rx="28" fill="url(#pk-hero)" stroke="#a3e15c" stroke-width="3" opacity="0.92"/>
  </g>
  <g transform="rotate(13 415 182)">
    <rect x="332" y="100" width="165" height="165" rx="28" fill="url(#pk-hero)" stroke="#f2c14e" stroke-width="3" opacity="0.92"/>
  </g>
  <g filter="url(#pk-glow)">
    <rect x="210" y="55" width="240" height="240" rx="38" fill="url(#pk-hero)" stroke="#5fe0d0" stroke-width="4.5"/>
    <rect x="222" y="67" width="216" height="80" rx="26" fill="#ffffff" opacity="0.05"/>
    <text x="330" y="242" text-anchor="middle" font-family="'Space Grotesk', system-ui, sans-serif" font-weight="800" font-size="190" fill="#eef2fb">P</text>
    <text x="428" y="278" text-anchor="end" font-family="'Space Grotesk', system-ui, sans-serif" font-weight="700" font-size="30" fill="#5fe0d0">10</text>
  </g>

  <!-- Wordmark -->
  <text x="330" y="430" text-anchor="middle" font-family="'Space Grotesk', system-ui, sans-serif" font-weight="800" font-size="90" letter-spacing="1">
    <tspan fill="#eef2fb">PALA</tspan><tspan fill="#5fe0d0">BRIKS</tspan>
  </text>

  <!-- Barra degradada (acentos por categoría de ficha) -->
  <rect x="150" y="452" width="360" height="7" rx="3.5" fill="url(#pk-under)"/>

  <!-- Tagline -->
  <text x="330" y="494" text-anchor="middle" font-family="'Space Grotesk', system-ui, sans-serif" font-weight="600" font-size="21" letter-spacing="5" fill="#8ea6cc">CONSTRUYE · TRANSFORMA · GANA</text>
</svg>`;
